/* eslint-disable */
import { MESSAGE_TYPES } from 'components';
import { addMessage } from 'store/actions/app';
import { keyValueMirror } from 'store/store-functions';

const {
    VITE_API_DEV_HOST,
    VITE_AUTHENTICATION_HOST,
    VITE_CLIENT_ID: clientId,
} = process.env;

const baseUrl = VITE_API_DEV_HOST;

export const actions = [
    'SET_ORG_LOADING',
    'GET_ORGANIZATIONS_ADMIN',
    'GET_ORGANIZATION_ID_ADMIN',
    'UPDATE_ORGANIZATION_ID_ADMIN',
    'CREATE_ORGANIZATION_ADMIN',
    'CLEAR_ORGANIZATION_MODELS_ADMIN',
    'GET_ORG_MODELS_ADMIN',
    'SET_SELECTED_ORG'

];

const keyActions = keyValueMirror(...actions);

export const setSelectedOrg = orgId => ({
    type: actions.SET_SELECTED_ORG,
    payload: orgId,
});

export const setOrgLoading = value => ({
    type: keyActions.SET_ORG_LOADING,
    payload: value,
});

export const clearOrgModelsAdmin = () => ({ type: keyActions.CLEAR_ORGANIZATION_MODELS_ADMIN });

export const getOrganizationsAdmin = token => async dispatch => {
    const params = window.location.search;

    const url = `${baseUrl}/admin/organizations${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setOrgLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to retrieve ArchVision Organizations.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: keyActions.GET_ORGANIZATIONS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Unable to retrieve ArchVision Organizations.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setOrgLoading(false));
    }
};

export const createOrganizationAdmin = (token, orgData) => async dispatch => {
    const url = `${baseUrl}/admin/organizations`;
    const data = {
        name: orgData.name,
        max_seats: orgData.max_seats,
    };
    const options = {
        method:'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to create organization.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const action = { type: keyActions.CREATE_ORGANIZATION_ADMIN };
        dispatch(action);
        dispatch(getOrganizationsAdmin(token));
    } catch (error) {
            const message = `Unable to create organization.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    }
};

export const getOrganizationIdAdmin = (token, orgId) => async dispatch => {
    const url = `${baseUrl}/admin/organizations/${orgId}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
       dispatch(setOrgLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to retrieve organization ${orgId}.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_ORGANIZATION_ID_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
        const message = `Unable to retrieve organization ${orgId}.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setOrgLoading(false));
    }
};

export const getOrgModelsAdmin = (token, orgId) => async dispatch => {
    const url = `${baseUrl}/admin/organizations/${orgId}/models`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to retrieve models.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_ORG_MODELS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Unable to retrieve models.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

export const updateOrgIdAdmin = (token, orgId, orgData) => async dispatch => {
    const { name } = orgData;
    const url = `${baseUrl}/admin/organizations/${orgId}`;
    const options = {
        method: 'PUT',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            name,
        }),
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to update organization.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: keyActions.UPDATE_ORGANIZATION_ID_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Error updating organization.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    }
};
